module.exports = __webpack_public_path__ + "media/images/payments/klarna-dark-845944cc6e6d73362a9b7f40a37a1b59.svg";